module.exports = __webpack_public_path__ + "static/media/remodulin-img1.0a6e86c1.PNG";